import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * 조건부 클래스를 합치고, 서로 부딪히는 Tailwind 유틸리티는 뒤에 온 쪽을 남긴다.
 *
 * 주의: 이 함수는 넘어온 className이 §5 허용 목록 안에 있는지 검사하지 않는다.
 * `<Button className="bg-red-500" />` 같은 코드도 그대로 동작한다.
 * 동작하니까 더 위험하다 — 리뷰에서 잡는다. (docs/tailwind-rules.md §5)
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
